function requestDataAdapter(amount) {
  return {
    amount: amount
  };
}

export { requestDataAdapter };
